type Row = {
  rank: number;
  title: string;
  tag: string;
  heat: number;
  unit: string;
  trend: "up" | "down" | "steady";
  change: string;
};

const rows: Row[] = [
  { rank: 1, title: "顶流深夜会所外被拍 · 全网追问同行者是谁", tag: "独家", heat: 973, unit: "万", trend: "up", change: "+28%" },
  { rank: 2, title: "爆款剧组杀青宴流出无剪辑现场视频", tag: "实锤", heat: 861, unit: "万", trend: "up", change: "+19%" },
  { rank: 3, title: "某选秀C位被扒出多年合约「甜饼」陷阱", tag: "内幕", heat: 742, unit: "万", trend: "up", change: "+12%" },
  { rank: 4, title: "热播综艺剪辑被锤「双标」剧本", tag: "反转", heat: 638, unit: "万", trend: "down", change: "-6%" },
  { rank: 5, title: "新晋小花与制片人深夜出入同一酒店", tag: "恋情", heat: 590, unit: "万", trend: "steady", change: "0" },
  { rank: 6, title: "顶流与前任团队隔空互撕九连更", tag: "开撕", heat: 512, unit: "万", trend: "up", change: "+8%" },
  { rank: 7, title: "直播间单场破亿后主播被曝刷单", tag: "黑料", heat: 460, unit: "万", trend: "down", change: "-11%" },
  { rank: 8, title: "剧组群演爆料：大牌一天片酬够买栋楼", tag: "内幕", heat: 401, unit: "万", trend: "steady", change: "0" },
];

function TrendBadge({ row }: { row: Row }) {
  if (row.trend === "up") {
    return (
      <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600">
        <i className="ri-arrow-up-line text-sm w-4 h-4 flex items-center justify-center" />
        {row.change}
      </span>
    );
  }
  if (row.trend === "down") {
    return (
      <span className="inline-flex items-center gap-1 text-xs font-medium text-secondary-600">
        <i className="ri-arrow-down-line text-sm w-4 h-4 flex items-center justify-center" />
        {row.change}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1 text-xs font-medium text-foreground-400">
      <i className="ri-subtract-line text-sm w-4 h-4 flex items-center justify-center" />
      持平
    </span>
  );
}

export default function HeatBoard() {
  const max = rows[0].heat;
  return (
    <section id="heat" className="mt-16 md:mt-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="border-t-2 border-foreground-950 pt-6 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="flex items-center gap-2 text-[11px] tracking-[0.25em] text-primary-700 font-label">
              <i className="ri-fire-fill text-accent-500 w-4 h-4 flex items-center justify-center" />
              CHIGUA HOT BOARD
            </p>
            <h2 className="mt-2 font-serif text-3xl font-black text-foreground-950 md:text-4xl">
              今日吃瓜热度榜 <span className="text-accent-500">TOP 8</span>
            </h2>
          </div>
          <p className="text-sm text-foreground-500 font-label">
            按全网搜索 · 讨论 · 转发综合热度排序 · 每 5 分钟更新
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {rows.map((row) => (
            <article
              key={row.rank}
              className="group flex items-center gap-4 rounded-lg border border-background-300/60 bg-background-50 p-3.5 transition-colors hover:border-primary-200 hover:bg-background-100/70 md:p-4 cursor-pointer"
            >
              <span
                className={`w-12 shrink-0 text-center font-serif font-black leading-none md:w-14 ${
                  row.rank === 1
                    ? "text-accent-500"
                    : row.rank === 2
                    ? "text-primary-500"
                    : "text-foreground-300"
                }`}
              >
                <span className="text-3xl md:text-4xl">{String(row.rank).padStart(2, "0")}</span>
                <span className="mt-1 block text-[10px] tracking-[0.2em] text-foreground-400 font-label font-medium">
                  RANK
                </span>
              </span>

              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="inline-flex shrink-0 items-center rounded-full bg-accent-100 px-2 py-0.5 text-[10px] font-medium text-accent-900">
                    {row.tag}
                  </span>
                  <TrendBadge row={row} />
                </div>
                <h3 className="mt-1.5 truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700 md:text-base">
                  {row.title}
                </h3>
                <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <div
                    className="h-full rounded-full bg-gradient-to-r from-primary-400 to-accent-500"
                    style={{ width: `${Math.round((row.heat / max) * 100)}%` }}
                  />
                </div>
              </div>

              <div className="shrink-0 text-right">
                <p className="font-serif text-lg font-black text-foreground-950 md:text-xl">
                  {row.heat}
                  <span className="ml-0.5 text-xs font-label font-medium text-foreground-500">{row.unit}</span>
                </p>
                <p className="text-[10px] tracking-wide text-foreground-400 font-label">热度</p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-6 flex items-center justify-center">
          <a
            href="#feed"
            className="inline-flex whitespace-nowrap items-center gap-2 text-sm font-medium text-primary-700 hover:text-primary-600 cursor-pointer"
          >
            去每日看点补完整时间线
            <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center" />
          </a>
        </div>
      </div>
    </section>
  );
}